// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateSettlementRules_wrapper__kCfgX","col":"CreateSettlementRules_col__2Utls"};